import { toast } from "sonner";
import { API } from "../lib/api";

/**
 * Inline `· get menu bar` link for the terminal edit page meta row. Mirrors
 * PWAInstallLink. Click → downloads the Chrome extension zip and shows a short
 * how-to-install toast. Renders its own leading separator.
 */
export default function ExtensionInstallLink() {
  const onClick = () => {
    // Trigger the download.
    window.location.href = `${API}/extension/download`;
    toast.message(
      "Menu bar downloaded. Install: unzip it → open chrome://extensions → turn on Developer mode → Load unpacked → pick the folder. (Chrome / Edge desktop)",
      { duration: 9000 },
    );
  };

  return (
    <>
      <span className="text-[#bbb]">·</span>
      <button
        type="button"
        onClick={onClick}
        className="tv-link"
        data-testid="terminal-install-extension"
        title="Get the persistent menu bar (Chrome / Edge extension)"
      >
        get menu bar
      </button>
    </>
  );
}
